import React from 'react'

import iconBack from '../assets/img/iconBack.png'


const Navigation = (props) => {


    const redirect =()=>{
        //console.log('clicou')
        window.location.href = "";
    }

    return (

        <>
            <div style={{
                height: 52, width: '100%', top: 0, backgroundColor: 'rgb(215,215,215)', display: 'flex',
                padding: '0.5rem'
            }}>
                <img src={iconBack} alt="" style={{ width: 35, height: 35,cursor:'pointer' }} onClick={redirect}/>
                <h2 style={{ color: 'rgb(127,127,127)', marginLeft: '0.5rem' }}>{props.titulo ? props.titulo : ' '}</h2>
            </div>
        </>
    )
}


export default Navigation